module.exports = __webpack_public_path__ + "static/img/adv1.bfb28a2b.png";